// MA-861 (PARENT-UX-2026-10-07 §4 Settings): Notifications merged into Emails (the recap toggle sits with its schedule and preview).
// The old link redirects to /parent/settings/email, carrying the search string (e.g. ?dev=1)
// as /parent/settings/kids does.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/parent/settings/notifications")({
  beforeLoad: ({ location }) => {
    throw redirect({ to: "/parent/settings/email", search: location.search as never, replace: true });
  },
  component: () => null,
});
